export class QuoteSiteContactModel {
  id?: number;
  quote_id?: number;
  name?: string;
  email?: string;
  number?: string;
  is_default?: boolean;
}
